export type Vector = number[];
